// Entry point for the build script in your package.json
import "./lib/admin_navigation"
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap";
// import {Tooltip, Popover} from "bootstrap";
// import "./editor/editor";
import "./recaptcha_bridge";
import "./setup_diagnostics";
import Swal from "sweetalert2";
window.Swal = Swal;
import Konva from "konva";
window.Konva = Konva;

// Initialize tooltips & popovers on Turbo load
document.addEventListener("turbo:load", () => {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
        new bootstrap.Tooltip(el);
    });
    document.querySelectorAll('[data-bs-toggle="popover"]').forEach(el => {
        new bootstrap.Popover(el);
    });
    document.querySelectorAll("#account-invitations-header .filters .choices").forEach(c => {
        const inner = c.querySelector(".choices__inner");
        if (!inner) return;
        const w = inner.getBoundingClientRect().width;
        c.style.setProperty("--choices-width", `${w}px`);
        const dd = c.querySelector(".choices__list--dropdown");
        if (dd) dd.style.width = `${w}px`;
    });

    // ✅ IMPORTANT: charity dashboard dropdowns should escape table scroll containers
    const charityDash = document.getElementById("charity-dashboard");
    if (charityDash) {
        charityDash.querySelectorAll('[data-bs-toggle="dropdown"]').forEach(el => {
            bootstrap.Dropdown.getOrCreateInstance(el, {
                popperConfig: {
                    strategy: "fixed",
                    modifiers: [
                        { name: "preventOverflow", options: { boundary: "viewport" } },
                        { name: "flip", options: { boundary: "viewport" } }
                    ]
                }
            });
        });
    }

});
document.addEventListener("turbo:before-cache", () => {
    document.querySelectorAll(".modal").forEach(modal => modal.remove());
    document.querySelectorAll(".tooltip").forEach(tooltip => tooltip.remove());
});

window.addEventListener("modal:hide", () => {
    const el = document.getElementById("contactEditModal")
    if (el) bootstrap.Modal.getOrCreateInstance(el).hide()
})
window.addEventListener("contact:updated", () => {
    // optional toast/snackbar
})
// import Swal from "sweetalert2"
// window.addEventListener("contact:added", () => {
//     Swal.fire({
//         title: "Contact added",
//         icon: "success",
//         timer: 1200,
//         showConfirmButton: false,
//         customClass: { popup: "swal2-ea-popup", title: "swal2-ea-title" }
//     })
// })
